import React from "react";
import Compressor from "compressorjs";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { Box, Button, FormControl, Grid, InputAdornment } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useAppDispatch, useAppSelector } from "../../helpers/hooks";
import { createSpoc, fetchSpocsList } from "../../features/spocs/spocsSlice";
import dayjs from "dayjs";
import { uploadFile } from "../../features/common/fileUploadSlice";
import Toaster from "../toaster";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import LoadingButton from "@mui/lab/LoadingButton";

interface file {
  lastModified: number;
  lastModifiedDate: {};
  name: string;
  size: number;
  type: string;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "visible",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const AddSpocs = ({ open, handleClose }: any) => {
  const dispatch = useAppDispatch();
  const usersState = useAppSelector((state) => state.userProfile.users);
  const [imageName, setImageName] = React.useState<Array<file>>([]);
  const [file, setFile] = React.useState([]);
  const [compressedFile, setCompressedFile] = React.useState([] as any);
  const [openToaster, setOpenToaster] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  const [toastType, setToastType] = React.useState("info");
  const [spocData, setSpocData] = React.useState({
    name: "",
    imageName: "",
    department: "",
    userId: localStorage.getItem("userId"),
    publishDate: "",
    email: "",
  });
  const [userData, setUserData] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");
  const [filteredOptions, setFilteredOptions] = React.useState([]);
  const [isDept, setIsDept] = React.useState(false);
  const [showLoaderOnSPOCPublish, setShowLoaderOnSPOCPublish] =
    React.useState(false);
  React.useEffect(() => {
    const userNames: any = usersState.map(
      (item: any, index: any) => item.userName
    );
    setUserData(userNames);
  }, []);

  const handleFormChange = (e: any) => {
    setSpocData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };
  const handleChange = (e: any, value: any) => {
    if (value !== null) {
      setIsDept(true);
      const userInfo: any = usersState.filter((item: any, index: any) => {
        return item.userName === value;
      });
      const modfiedSpoc = {
        name: userInfo[0].userName,
        imageName: "",
        department: userInfo[0].department,
        userId: userInfo[0].id,
        publishDate: "",
        email: userInfo[0].userEmail,
      };

      setSpocData(modfiedSpoc);
    } else {
      setSpocData({
        name: "",
        imageName: "",
        department: "",
        userId: "",
        publishDate: "",
        email: "",
      });
    }
  };
  const handleInputChange = (e: any) => {
    const value: string = e;
    setInputValue(value);
    if (value) {
      const chars = value.toLowerCase().split("");
      const filteredSuggestions =
        value?.length > 0
          ? userData.filter((name: any) => {
              return chars.every((char) =>
                name?.replaceAll(" ", "").toLowerCase().includes(char)
              );
            })
          : [];
      setFilteredOptions(filteredSuggestions);
    } else {
      setIsDept(false);
      setFilteredOptions([]);
    }
  };
  const handleToasterClose = () => {
    setOpenToaster(false);
  };
  const compressImage = (file: File): Promise<File> => {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        width: 512,
        height: 512,
        convertTypes: ["image/jpeg"],
        success(result: any) {
          resolve(new File([result], file.name, { type: result.type }));
        },
        error(err) {},
      });
    });
  };

  const handleUploadClick = async (e: any) => {
    const compressedImage: any = await compressImage(e.target.files[0]);
    setCompressedFile(compressedImage);
    setImageName(e.target.files);
    setFile(e.target.files);
  };

  const createSpocData = (e: any) => {
    e.preventDefault();
    if (spocData.name == "") {
      setOpenToaster(true);
      setToastType("error");
      setToastMessage("Name Is Mandatory");
      return;
    }
    if (file.length > 0) {
      setShowLoaderOnSPOCPublish(true);
      let formData = new FormData();
      formData.append("file", compressedFile);
      dispatch(uploadFile(formData)).then((res) => {
        if (res.meta.requestStatus == "fulfilled") {
          let postBody = { ...spocData };
          postBody.imageName = res.payload;
          postBody.publishDate = dayjs().format("YYYY-MM-DD");

          dispatch(createSpoc(postBody)).then((res) => {
            setOpenToaster(true);
            dispatch(fetchSpocsList());
            setToastType("success");
            setToastMessage("SPOC created successfully!");
            setTimeout(() => {
              setShowLoaderOnSPOCPublish(false);
              handleClose();
            }, 1000);
            return;
          });
        }
      });
    } else {
      setShowLoaderOnSPOCPublish(true);
      let postBody = { ...spocData };
      postBody.imageName = imageName[0] ? imageName[0].name : "";
      postBody.publishDate = dayjs().format("YYYY-MM-DD");

      dispatch(createSpoc(postBody)).then((res) => {
        setOpenToaster(true);
        dispatch(fetchSpocsList());
        setToastType("success");
        setToastMessage("SPOC created successfully!");
        setTimeout(() => {
          handleClose();
          setShowLoaderOnSPOCPublish(false);
        }, 1000);
      });
    }
  };

  const deleteImage = (e: any) => {
    e.preventDefault();
    setImageName([]);
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="lg"
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
          className="modal-title"
        >
          Add Spoc
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ backgroundColor: "#EAEBEB" }}>
          <Box component="form" noValidate>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Name">
                    <Autocomplete
                      disablePortal
                      options={filteredOptions}
                      noOptionsText={
                        filteredOptions.length === 0 ? "No users found" : ""
                      }
                      sx={{ width: 300 }}
                      onInputChange={(e, v) => handleInputChange(v)}
                      onChange={(e, value) => handleChange(e, value)}
                      filterOptions={(filteredOptions) => filteredOptions}
                      renderInput={(params) => (
                        <TextField
                          name="name"
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: null, // This removes the down arrow
                          }}
                          size="small"
                        />
                      )}
                    />
                  </DemoItem>
                </FormControl>
              </Grid>

              <Grid size={{ xs: 6 }}>
                {isDept && (
                  <FormControl variant="standard" fullWidth>
                    <DemoItem label="Department">
                      <OutlinedInput
                        name="department"
                        disabled
                        value={spocData.department}
                        placeholder="Add here"
                        id="bootstrap-input"
                        size="small"
                        onChange={(e) => handleFormChange(e)}
                      />
                    </DemoItem>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 6 }}>
                <FormControl variant="standard" fullWidth>
                  <DemoItem label="Add Image">
                    <Button
                      component="label"
                      role={undefined}
                      variant="outlined"
                      tabIndex={-1}
                      sx={{ textTransform: "capitalize" }}
                      className="image-upload-button"
                    >
                      Upload Photo
                      <VisuallyHiddenInput
                        type="file"
                        accept="image/*"
                        multiple={false}
                        onChange={(e: any) => handleUploadClick(e)}
                      />
                    </Button>
                  </DemoItem>
                </FormControl>
                {imageName.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      marginTop: "10px",
                    }}
                    gap={2}
                  >
                    <OutlinedInput
                      size="small"
                      value={imageName[0]?.name}
                      className="image-name-style"
                      sx={{ color: "primary" }}
                      endAdornment={
                        <InputAdornment position="end">
                          <DeleteOutlinedIcon
                            fontSize="small"
                            color="primary"
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => deleteImage(e)}
                          />
                        </InputAdornment>
                      }
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ alignSelf: "center" }}>
          <LoadingButton
            loading={showLoaderOnSPOCPublish}
            loadingIndicator="Please wait…"
            variant="contained"
            sx={{ textTransform: "capitalize" }}
            className="mui-modal-button"
            onClick={(e) => createSpocData(e)}
          >
            Publish
          </LoadingButton>
        </DialogActions>
      </BootstrapDialog>
      <Toaster
        openToaster={openToaster}
        toastMessage={toastMessage}
        type={toastType}
        handleToasterClose={handleToasterClose}
      />
    </>
  );
};
export default AddSpocs;
